import { connect } from 'react-redux';
import View from './LargePurchaseGoalsCRUDView';
import { largePurchaseGoalsSelector } from '../../../GoalsCRUDSelector';
import { fetchData } from '../../../AdvWorkflow/AdvWorkflowActions';
import {
  isPopulatedSelector,
  currentClientId,
  iterator,
  selectedGoalIdSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import {
  onAddNewGoal,
  onGoalEdit,
  onGoalDelete,
  getDesiredPurchaseYear,
} from './LargePurchaseGoalsCRUDActions';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  largePurchaseGoals: largePurchaseGoalsSelector(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
  iterator: iterator(state, ownProps),
  selectedGoalId: selectedGoalIdSelector(state),
});

const mapDispatchToProps = dispatch => ({
  getDesiredPurchaseYear,
  onAddNewGoal: (workflowId, clientId) => () => {
    dispatch(onAddNewGoal(workflowId, clientId));
  },
  onGoalEdit: (largePurchaseGoal, workflowId, clientId) => () => {
    dispatch(onGoalEdit(largePurchaseGoal, workflowId, clientId));
  },
  fetchData: (workflowId, clientId) => {
    dispatch(fetchData(workflowId, clientId, ['LargePurchaseGoals'], true));
  },
  onGoalDelete: (goalId, largePurchaseGoals, workflowId, clientId) => {
    dispatch(onGoalDelete(goalId, largePurchaseGoals, workflowId, clientId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
